import { render } from "./PendingStatistics.vue?vue&type=template&id=97d98ec6&ts=true"
import script from "./PendingStatistics.vue?vue&type=script&lang=ts"
export * from "./PendingStatistics.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__